import { EndUserConstants, EndUserError } from "../euscp/euscp";
import { arrayToBase64, base64ToArray } from "./Utils";

export default class UmCAService {
  constructor(port) {
    if (!port) {
      port = "25989";
    }
    if (typeof port !== "string") {
      port = String(port);
    }
    this.baseUrl = `https://localhost:${port.trim()}/`;
  }

  async tryConnect() {
    try {
      const responce = await fetch(this.baseUrl + "about");
      return responce.ok && typeof (await responce.json()).AppID === "string";
    } catch (error) {
      return false;
    }
  }

  async getKeys() {
    const responce = await fetch(this.baseUrl + "keystores?ReadCertificates=true&KeyParams=true");

    if (!responce.ok) {
      const error = await responce.json();
      throw {
        code: EndUserError.EU_ERROR_TRANSMIT_REQUEST,
        message: error.Message
      };
    }
    const keys = await responce.json();
    return keys.map(key => {
      let description = key.Description;
      const ki = key.Description.indexOf("KeyStores");
      if (ki > 0) {
        description = description.substring(ki);
      }

      return {
        alias: key.Certs[0].CertificateSerialNumber,
        visibleName: description,
        certificates: key.Certs.map(c => c.Base64),
        password: null
      };
    });
  }

  async signData(key, toSign, signType, asByteArray) {
    let sigType;

    if (signType.type === EndUserConstants.EU_SIGN_CONTAINER_TYPE_PADES) {
      sigType = "pdf-attached";
    } else {
      if (signType.signLevel >= EndUserConstants.EU_SIGN_TYPE_CADES_C) {
        sigType = "cades-x-ts-signtime-ocsp-stdua";
      } else {
        sigType = "cms-ts-signtime";
      }
      if (signType.subType === EndUserConstants.EU_CADES_TYPE_ENVELOPED) {
        sigType += "-attached";
      }
    }

    let returnArray = true;
    if (!Array.isArray(toSign)) {
      returnArray = false;
      toSign = [toSign];
    } else {
      toSign = [...toSign];
    }

    for (let i = 0; i < toSign.length; i++) {
      const d = toSign[i];
      if (d.val) {
        toSign[i] = { name: d.name, val: formatData(d.val, true) };
      } else {
        toSign[i] = formatData(d, true);
      }
    }

    const results = [];
    for (const data of toSign) {
      const request = new Request(this.baseUrl + "sign", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          Data: data.val ? data.val : data,
          Certificate: key.certificates[0],
          Pin: key.password,
          SigType: sigType,
          AsBlob: false,
          AsResource: false,
          DataAsLink: false
        }),
      });

      const responce = await fetch(request);
      if (!responce.ok) {
        const error = await responce.json();
        throw {
          code: EndUserError.EU_ERROR_TRANSMIT_REQUEST,
          message: error.Message
        };
      }

      const sign = await responce.json();
      results.push(data.name ? { name: data.name, val: sign } : sign);
    }
    for (let i = 0; i < results.length; i++) {
      const r = results[i];
      if (r.val) {
        results[i] = { name: r.name, val: formatData(r.val, !asByteArray) };
      } else {
        results[i] = formatData(r, !asByteArray);
      }
    }
    return returnArray ? results : results[0];
  }
}

const formatData = (data, toBase64) => {
  return toBase64 && typeof data != "string" ? arrayToBase64(data)
    : !toBase64 && typeof data == "string" ? base64ToArray(data)
      : data;
};
